import styled from "styled-components";
import { MiddleNftImg } from "../../shared/icons";

const Section = styled.section`
  display: flex;
  align-items: center;
  padding: 50px 20px;
  background-color: #f9f9f9;
`;

const ImageWrapper = styled.div`
  flex: 1;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;

  h2 {
    font-size: 36px;
    font-weight: 400;
    line-height: 45px;
    color: #1e440b;
    margin-bottom: 10px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    color: #1e440b;
    line-height: 24px;
  }
`;

const MiddleSection = () => {
  return (
    <Section>
      <ImageWrapper>
        <img src={MiddleNftImg} alt="MiddleNftImg" />
      </ImageWrapper>
      <Content>
        <h2>Empowering Sustainability: Join Us in Creating a Greener Future</h2>
        <p>
          We’re committed to making a real difference through sustainability
          initiatives that prioritize environmental health, resource
          conservation, and community impact. From reforestation projects to
          renewable energy adoption, each effort brings us closer to a cleaner,
          more sustainable world. By joining us, you’re not only supporting
          these initiatives but also becoming part of a community dedicated to
          positive, lasting change. Discover the ways you can get involved and
          contribute to building a future where sustainability is at the core of
          every choice.
        </p>
      </Content>
    </Section>
  );
};

export default MiddleSection;
